<template>
  <div style="text-align: left">
    <el-dialog title="登录用户" :close-on-click-modal="false" :visible.sync="isVisible">
      <el-row>
        <el-col :span="24" class="layout-col">
          <el-card class="table-card" :body-style="{ padding: '0px' }">
            <div slot="header" class="table-card-header">
              <span>登录用户</span>
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="addOrUpdate(undefined)">新增</el-button>
            </div>
            <el-table
              :data="tableData"
              border
              highlight-current-row
              style="width: 100%"
              ref="table"
            >
              <!-- prop  对应列内容的字段名，也可以使用 property 属性 
                 label 属性来定义表格的列名
            -->
              <el-table-column
                prop="name"
                label="用户名"
                min-width="80"
                align="center"
              >
              </el-table-column>
              <el-table-column label="状态" width="150" >
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.isEnable===0" >启用</el-tag>
                  <el-tag  type="warning" v-if="scope.row.isEnable===1" >禁用</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="150" >
                <template slot-scope="scope">
                  <el-button type="text" size="mini" v-if="isAuth('customerInfo:setuser')"  @click="resertPassword(scope.row.id)">重置密码</el-button>
                  <el-button type="text" size="mini" v-if="isAuth('customerInfo:setuser')&&scope.row.isEnable===0"  @click="setEnabled(scope.row.id,1)">禁用登录</el-button>
                  <el-button type="text" size="mini" v-if="isAuth('customerInfo:setuser')&&scope.row.isEnable===1"  @click="setEnabled(scope.row.id,0)">启用登录</el-button>
                  <el-button type="text" size="mini" v-if="isAuth('customerInfo:setuser')"  @click="addOrUpdate(scope.row)">修改</el-button>
                  <el-button type="text" size="mini" v-if="isAuth('customerInfo:setuser')"  @click="deleteTableData(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total, prev, pager, next"
              :total="totalElements"
              @current-change="tablePaging"
            >
            </el-pagination>
          </el-card>
        </el-col>
        <el-col :span="12" class="layout-col"> </el-col>
      </el-row>
    </el-dialog>
    <!-- 添加模态框 -->
    <el-dialog
      title=""
      :visible="true"
      @close="editDialogClose"
      v-if="editDialogStatus"
    >
      <!-- <edit-form-builder :entityPropertys="entityPropertys" :formData="editFormData" :colsOfRow="editFormColsOfRow" :formStatus="editDialogStatus"></edit-form-builder> -->
      <el-form ref="addOrUpdateForm" :model="form" :rules="insertRules" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户名" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogStatus = false">取 消</el-button>
        <el-button type="primary" @click="saveEditFormData">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import request from "@/utils/request";
import Template from "../../../template";
export default {
  name: "table-list",
  components: {Template},
  data() {
    return {
      edit:true,
      customerId:'',
      form: {
        id:'',
        name:'',
        password:'',
        isEnable:''
      },
      isVisible: true,
      //列表数据
      tableData: [],
      totalElements: 0,
      pageNumber: 1,
      editDialogStatus: false,
      //表单验证规则
      insertRules: {
        //每年只有一条考核，对年度进行限制
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          }
        ]
      },
    };
  },
  methods: {
    init (id) {
      if(!id) return
      this.customerId = id
      this.isVisible = true
      this.fetchTableData()
      this.$nextTick(()=>{

      })
    },
    fetchTableData() {

      request({
        url: "/bjba/customerUser/list",
        method: "get",
        params: {
          page: this.pageNumber,
          pagesize: 10,
          customerId:this.customerId,
        },
      }).then((response) => {
          const data = response.data;
          this.tableData = data.data.content;
          this.totalElements = data.data.totalElements;

        })
        .catch((error) => {
          console.log(error);
        });
    },
    resertPassword (id) {
      this.$confirm(`确定进行[重置密码]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: `/bjba/customerUser/resertPassword`,
          method: 'post',
          params: {id:id}
        }).then(({data}) => {
          if (data && data.code === 200) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500
            })
            this.fetchTableData()
          } else if(data && data.code ==500) {
            this.$message({
              message: data.message,
              type: 'error',
              duration: 1500
            })
          }
        })
      }).catch(() => {
      })
    },

    setEnabled (id,isEnable) {
      this.$confirm(`确定进行[${isEnable===0?'启用登录':'禁用登陆'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: `/bjba/customerUser/setEnabled`,
          method: 'post',
          params: {id:id,isEnable: isEnable}
        }).then(({data}) => {
          if (data && data.code === 200) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500
            })
            this.fetchTableData()
          } else if(data && data.code ==500) {
            this.$message({
              message: data.message,
              type: 'error',
              duration: 1500
            })
          }
        })
      }).catch(() => {
      })
    },
    delete(id) {

    },
    //保存用户信息
    saveEditFormData() {
      let formData ={}
      formData = this.form

      this.$refs["addOrUpdateForm"].validate((valid) => {
        if (!valid){
          console.log('error submit!!');
          return false;
        }
        request({ 
          url: "/bjba/customerUser/save",
          method: "post",
          data: {id:this.form.id,
            name:this.form.name,
            password:this.form.password,
            isEnable:this.form.isEnable,
            customerId:this.customerId
          },
        }).then((response) => {
            const data = response.data
          if (data && data.code === 200) {
            this.$message({
              message: '添加成功',
              type: 'success',
              duration: 1500
            })

            this.editDialogStatus = false;
            this.fetchTableData()
          } else {
            this.$message({
              message: data.message,
              type: 'error',
              duration: 1500
            })
          }
          }).catch((error) => {
            console.log(error);
            this.$message("操作失败");
          });
      }) 
    },

    //删除亲属数据
    deleteTableData(row) {
      console.log(row);
      let data = row;
      this.$confirm("确定删除用户吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
          request({
            url: "/bjba/customerUser/delete",
            method: "post",
            data: [row.id],
          }).then((response) => {
            let data = response.data
            if (data && data.code === 200) {
              this.$message({
                message: '删除成功',
                type: 'success',
                duration: 1500
              })
              this.fetchTableData()
            } else {
              this.$message({
                message: data.message,
                type: 'error',
                duration: 1500
              })
            }
            }).catch((error) => {
              console.log(error);
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            });
        })
        .catch(() => {});
    },
    addOrUpdate(row) {
      this.editDialogStatus = true
      this.$nextTick(()=>{
        if (row) {
          this.form.id =row.id
          this.form.name = row.name
          this.form.password = row.password
          this.form.isEnable = row.isEnable
        } else {
          this.form.id =''
          this.form.name = ''
          this.form.password = ''
          this.form.isEnable = ''

        }
      })
    },

    editDialogClose() {
      this.editDialogStatus = false;

    },


    tablePaging(pageNumber) {
      this.pageNumber = pageNumber;
      this.fetchTableData();
    },
  },
};
</script>
<style scoped>
.layout-col {
  text-align: center;
}
.search-input {
  width: 80%;
  margin: 5px;
}

.table-card-header {
  text-align: left;
}
.dialog-footer {
  text-align: center;
}
.el-icon-search,
.el-icon-edit,
.el-icon-delete {
  cursor: pointer;
}
</style>
